<form [formGroup]='movingFrom'
      (ngSubmit)='onSubmit()'
      id='{{formGroupName}}'>

	<div class='step-title' i18n>Where exactly are you moving <span class='color-blue'>from</span>?</div>
	<div class='fields-group'>

		<div class='form-control form-control-full'>
			<mat-form-field>
				<mat-label i18n='@@labelCountry'>Country</mat-label>
				<select matNativeControl
				        (change)="onCountryChange()"
				        [tabIndex]='formService.verifyTabIndex( formGroupName )'
				        [attr.disabled]='this.enableFields ? null : "disabled"'
				        formControlName='country'>
					<option *ngIf="!movingFrom.controls['country'].value" [ngValue]="null" selected i18n='@@selectPlaceholder'>&nbsp;- Select -</option>
					<optgroup *ngIf='formService.popularCountries && formService.popularCountries.length' i18n-label='@@labelPopularCountries' label='&nbsp;Popular'>
						<option *ngFor='let country of formService.popularCountries'
						        [value]='country.country_code'>
							{{country.country}}
						</option>
					</optgroup>
					<optgroup i18n-label='@@labelAllCountries' label='&nbsp;All countries'>
						<option *ngFor='let country of formService.countries'
						        [value]='country.country_code'>
							{{country.country}}
						</option>
					</optgroup>
				</select>
			</mat-form-field>
		</div>

		<ng-container *ngFor='let fieldType of fieldOrder'>
			<div *ngIf='fieldType == "address"' class='form-control form-control-full'>
				<mat-form-field [hideRequiredMarker]="true">
					<mat-label>{{labelAddress}}</mat-label>
					<input formControlName='address'
					       (input)="formService.markAddressInput( 'movingFrom' )"
					       name='address'
					       placeholder=''
					       type='text'
					       #addressInputEl
					       [tabIndex]='formService.verifyTabIndex( formGroupName )'
					       [attr.disabled]='this.enableFields ? null : "disabled"'
					       [matAutocomplete]="auto"
					       matInput>
					<mat-autocomplete #auto="matAutocomplete" 
					                  (optionSelected)="onSelectSuggestion($event.option.value); addressInputEl.blur()"
					                  [displayWith]="displayWithTyped">
						<mat-option *ngFor="let suggestion of autocompleteSuggestions$ | async" [value]="suggestion">
							{{ suggestion.placePrediction?.text || suggestion.text }}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
			</div>
			<div *ngIf='fieldType == "postcode" && postcodeEnabled' class='form-control form-control-small'>
				<mat-form-field>
					<mat-label>{{labelPostcode}}</mat-label>
					<input matInput
					       formControlName='postcode'
       (input)="formService.markAddressInput( 'movingFrom' )"
					       placeholder=''
					       type='text'
					       [tabIndex]='formService.verifyTabIndex( formGroupName )'
					       (keyup)="onPostcodeFieldKeyup($event)"
					       [attr.disabled]='this.enableFields ? null : "disabled"'
					       name='postcode'/>
				</mat-form-field>
			</div>
			<div *ngIf='fieldType == "city"' class='form-control form-control-wide' [class]='!postcodeEnabled ? "form-control-full" : ""'>
				<mat-form-field>
					<mat-label i18n='@@labelCity'>City</mat-label>
					<input matInput
					       formControlName='city'
       (input)="formService.markAddressInput( 'movingFrom' )"
					       name='city'
					       type='text'
					       [attr.disabled]='this.enableFields ? null : "disabled"'
					       [tabIndex]='formService.verifyTabIndex( formGroupName )'
					       placeholder=''/>
				</mat-form-field>
			</div>
		</ng-container>

		<div *ngIf='isStateFieldEnabled()' class='form-control form-control-full'>
			<mat-form-field>
				<mat-label i18n='@@labelState'>State</mat-label>
				<select matNativeControl
				        formControlName='state'
				        [tabIndex]='formService.verifyTabIndex( formGroupName )'
				        [attr.disabled]='this.enableFields ? null : "disabled"'
				        [attr.required]='isStateFieldEnabled()'
				        name='state'>
					<optgroup label="States">
						<option *ngFor='let state of states'
					        [value]='state.code'>
						{{state.name}}
						</option>
					</optgroup>
				</select>
			</mat-form-field>
		</div>

	</div>
	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='submit' type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>
		</div>
	</div>
</form>